import moment from "moment";
import { Role, Searcher } from "../interfaces";
import { capitalizeString } from "../shared/util";

export class RolesAdapter {
    value: any;

    constructor(input: any) {
        this.value = input;
    }

    adapt(): Role {
        return {
            id: this.value.id,
            name : this.value.name
        };
    }
}
